import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const crearActivosService = {
    getAllCrearActivos,
    getCrearActivoById,
    setStateCrearActivoById,
    crudCrearActivos,
    getTipoActivos,
    getReferencias,
    getPropietarios,
    getUbicaciones,
    getEstadoActivos,
    getEstadosDisponibilidad,
    getFilteredData,
    getAccesoriosByReferencia,
    getInfoActivos,
    getAgentesComerciales
};

async function getAllCrearActivos() {
//   loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    let res = await fetch(`${url}/crearActivos/getAllCrearActivos`, requestOptions)
    return res.json()
}

function getCrearActivoById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/crearActivos/getCrearActivoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudCrearActivos(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/crearActivos/crudCrearActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateCrearActivoById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/crearActivos/setStateCrearActivoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getTipoActivos(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/crearActivos/getTipoActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getReferencias(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/crearActivos/getReferencias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPropietarios() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/crearActivos/getPropietarios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getUbicaciones() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/crearActivos/getUbicaciones`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getEstadoActivos(data) {
  // loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/crearActivos/getEstadoActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getEstadosDisponibilidad() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/crearActivos/getEstadosDisponibilidad`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFilteredData(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/crearActivos/getFilteredData`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAccesoriosByReferencia(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/crearActivos/getAccesoriosByReferencia`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}


//CONSULTA INFORME SOLICITUD
function getInfoActivos() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/crearActivos/informeActivos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAgentesComerciales() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/crearActivos/getAgentesComerciales`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}





